export type PermitSuiteTab = "pipeline" | "plan_review" | "assistant";

export type PermitHubSection = "permit_suite" | "form_extraction" | "plan_review";

export function tabForPermitHubSection(section: PermitHubSection): PermitSuiteTab {
  switch (section) {
    case "form_extraction":
      return "assistant";
    case "plan_review":
      return "plan_review";
    case "permit_suite":
      return "pipeline";
    default: {
      const _exhaustive: never = section;
      return _exhaustive;
    }
  }
}

export function sectionForPermitTab(tab: PermitSuiteTab): PermitHubSection {
  switch (tab) {
    case "assistant":
      return "form_extraction";
    case "plan_review":
      return "plan_review";
    case "pipeline":
      return "permit_suite";
    default: {
      const _exhaustive: never = tab;
      return _exhaustive;
    }
  }
}

export function isPermitHubSection(section: string): section is PermitHubSection {
  return section === "permit_suite" || section === "form_extraction" || section === "plan_review";
}
